import type { Context, Provider } from 'react';
import { createContext } from 'react';

export const LeftNavWidthOverrideContext: Context<number | null> = createContext<number | null>(null);

export const LeftNavWidthOverrideProvider: Provider<number | null> = LeftNavWidthOverrideContext.Provider;
